import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ELocalStorage } from '../enums/ELocalStorage';
import { EModelApiPaths } from '../enums/EModelApiPaths';
import { EAuthTokenType, EGetEncryptedData, EHeader, IAPIResponse, IDecryptDataFETransfer, IDecryptDataFETransferPayload, IQueryFormat } from '../enums/types';
import { environment } from '../../environments/environment';
import { UtilsService } from './utils.service';
import { IUser } from '../interfaces/IUser';
import { AuthService } from './auth.service';
import { ECollection } from '../enums/ECollection';
import { BaseService } from './base-service';
import { Subject } from 'rxjs';
import { Router } from "@angular/router";

@Injectable({
    providedIn: 'root'
})
export class UserService extends BaseService {
    amUser: { accessAMToken: '', refreshAMToken: '' } | any;
    gUser = new Subject<any>();

    token = {
        accessToken: '',
        refreshToken: '',
    };

    constructor(public override http: HttpClient,
                public authService: AuthService,
                public router: Router,
                public override utilsService: UtilsService,) {
        super(http, <any>null, utilsService, `/schema/${environment.USER_PATH}/${environment.INS}/${environment.DB}/${ECollection.MP_USERS}`);
        this.getThis().userService = this.userService;

        this.gUser.subscribe(async (data) => {
            if (!data) return;
            const tempUser = <any>this.authService.gUser;
            if (data.action === 'REFRESH_G_USER') {
                const userInfoRes = await this.loadGUserInfo(tempUser._id);
                this.authService.setUserToLocalStorage(userInfoRes[0], environment.crypto.passJWT);
            }
        });
    }

    async loadGUserInfo(id: string) {
        const findString = JSON.stringify({ _id: id });
        const resp = <any>await this.http.get(environment.GUDIYA_ENTERPRISES_BE_HOST_PORT_SITES + `${this.modelPath}?find=` + findString, this.getRequestOptions()).toPromise();
        if (this.isEncrypted) return this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
        else return resp.data;
    }

    async getAMToken() {
        const encryptedPayload = this.utilsService.getEncryptedString(<IDecryptDataFETransferPayload>{
            data: this.utilsService.authTokenAM,
            createdAt: new Date(),
        }, environment.crypto.passJWT);
        const res: IAPIResponse<IUser> = <any>await this.http.post(environment.GUDIYA_ENTERPRISES_BE_HOST_PORT_SITES + EModelApiPaths.SYSTEM_API_BASE + `/${environment.USER_PATH}/token`,
            <IDecryptDataFETransfer>{ dataEncFE: encryptedPayload }, {
                headers: {
                    [EHeader.ENCRYPTED_PAYLOAD]: 'true',
                },
            }).toPromise();
        return res.data;
    }

    async getAMAdminAndRootToken(dataItems: any) {
        const encryptedPayload = this.utilsService.getEncryptedString(<IDecryptDataFETransferPayload>{
            data: dataItems,
            createdAt: new Date(),
        }, environment.crypto.passJWT);
        const res: IAPIResponse<IUser> = <any>await this.http.post(environment.GUDIYA_ENTERPRISES_BE_HOST_PORT_SITES + EModelApiPaths.SYSTEM_API_BASE + `/${environment.USER_PATH}/token`,
            <IDecryptDataFETransfer>{ dataEncFE: encryptedPayload }, {
                headers: {
                    [EHeader.ENCRYPTED_PAYLOAD]: 'true',
                },
            }).toPromise();
        return res.data;
    }

    async login(usr_userName_str: string, usr_pass_str: string) {
        const amToken = <any>await this.getAMToken();
        if (amToken) {
            const encryptedPayload = <IDecryptDataFETransfer>{
                dataEncFE: this.utilsService.getEncryptedString(<IDecryptDataFETransferPayload>{
                    data: {
                        usr_userName_str,
                        usr_pass_str,
                    },
                    createdAt: new Date(),
                }, environment.crypto.passJWT),
            };
            const resp = <any>await this.http.post(environment.GUDIYA_ENTERPRISES_BE_HOST_PORT_SITES + EModelApiPaths.CUSTOM_API_BASE + `/${environment.USER_PATH}` + EModelApiPaths.USER_LOGIN, encryptedPayload, {
                headers: {
                    [EHeader.AUTHORIZATION_AM]: amToken.token,
                    [EHeader.ENCRYPTED_PAYLOAD]: 'true',
                    [EHeader.GET_ENCRYPTED_DATA]: EGetEncryptedData.get_only_encryption,
                },
            }).toPromise();
            const dataItem = this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
            // const amAdminRootToken = <any>await this.getAMAdminAndRootToken(this.utilsService.authTokenAM);
            // this.setAMUserToLocalStorage({
            //   accessAMToken: amAdminRootToken.token,
            //   refreshAMToken: amAdminRootToken.refresh_token,
            // }, environment.crypto.passJWT);

            this.setAMUserToLocalStorage({
                accessAMDBToken: dataItem.accessToken,
                refreshAMToken: dataItem.refresh_token,
                amToken: dataItem.amToken,
            }, environment.crypto.passJWT);
            this.amUser.accessAMToken = dataItem.amToken;
            this.amUser.accessAmDBToken = dataItem.accessToken;
            return dataItem;
        }
    }

    async refreshToken() {
        if (this.authService.gUser && this.authService.gUser._id) {
            const authTokenAM = {
                authTokenType: EAuthTokenType.AM,
                authTokenAM: { refresh_token: this.amUser.refreshAMToken },
            };
            const authTokenAMDB = {
                authTokenType: EAuthTokenType.AM_DB,
                authTokenAMDB: { refresh_token: this.authService.token.refreshToken },
            };
            const res = <any>await this.http.post(environment.GUDIYA_ENTERPRISES_BE_HOST_PORT_SITES + EModelApiPaths.SYSTEM_API_BASE + `/${environment.USER_PATH}/token`, [authTokenAM, authTokenAMDB]).toPromise();

            if (!res.data[0] || !res.data[1]) return this.authService.logout();

            // AM User
            const amUser = this.amUser;
            amUser.accessAMToken = <any>res.data[0].token;
            amUser.amToken = <any>res.data[0].token;
            amUser.refreshAMToken = <any>res.data[0].refresh_token;

            // AM_DB user
            const user: IUser = this.authService.gUser;
            this.authService.token.accessToken = res.data[1].token;
            this.authService.token.refreshToken = res.data[1].refresh_token;
            amUser.accessAMDBToken = res.data[1].token;
            this.authService.setUserToLocalStorage(user, environment.crypto.passJWT);
            this.setAMUserToLocalStorage(amUser, environment.crypto.passJWT);
            // await this.updateUser<IUser>(user._id, { lastLoginTime: new Date() }, {});
        }
    }

    setAMUserToLocalStorage(userObj: any, p: string) {
        this.amUser = userObj;
        const encryptedCode = this.utilsService.getEncryptedString(this.amUser, p);
        (<any>window).localStorage.setItem('AM_USER', encryptedCode);
    }

    getAMUserFromLocalStorage(p: string) {
        const value = (<any>window).localStorage.getItem('AM_USER');
        if (value) {
            const decryptedObj = this.utilsService.getDecryptedObject(value, p);
            if (decryptedObj) return decryptedObj;
            else (<any>window).localStorage.setItem('AM_USER', '');
        }
    }

    // getRequestOptions() {
    //   return {
    //     headers: {
    //       [EHeader.AUTHORIZATION_AM]: this.amUser.accessAMToken,
    //       [EHeader.AUTHORIZATION_AM_USER]: this.authService.token.accessToken,
    //       [EHeader.ENCRYPTED_PAYLOAD]: environment.IS_ENCRYPTED ? 'true' : 'false',
    //       [EHeader.GET_ENCRYPTED_DATA]: environment.IS_ENCRYPTED
    //         ? EGetEncryptedData.get_only_encryption : EGetEncryptedData.no_encryption,
    //       [EHeader.SANDBOX_TIMEOUT]: (60 * (1000 * 60)).toString(), // 10 minutes
    //     },
    //   };
    // }

    getRequestOptions() {
        let localData = this.getAMUserFromLocalStorage(environment.crypto.passJWT);
        let headers: any;
        if (localData) {
            headers = {
                headers: {
                    [EHeader.AUTHORIZATION_AM]: localData.amToken,
                    [EHeader.AUTHORIZATION_AM_USER]: localData.accessAMDBToken,
                    [EHeader.ENCRYPTED_PAYLOAD]: environment.IS_ENCRYPTED ? 'true' : 'false',
                    [EHeader.GET_ENCRYPTED_DATA]: environment.IS_ENCRYPTED
                        ? EGetEncryptedData.get_only_encryption : EGetEncryptedData.no_encryption,
                    [EHeader.SANDBOX_TIMEOUT]: (30 * (1000 * 60)).toString(), // 10 minutes
                },
            };
        } else {
            headers = {
                headers: {
                    [EHeader.AUTHORIZATION_AM]: window.localStorage.getItem(ELocalStorage.DEFAULT_AM_AUTH),
                    [EHeader.ENCRYPTED_PAYLOAD]: environment.IS_ENCRYPTED ? 'true' : 'false',
                    [EHeader.GET_ENCRYPTED_DATA]: environment.IS_ENCRYPTED
                        ? EGetEncryptedData.get_only_encryption : EGetEncryptedData.no_encryption,
                    [EHeader.SANDBOX_TIMEOUT]: (30 * (1000 * 60)).toString(), // 10 minutes
                },
            };
        }
        return headers;
    }

    async amUserQuery<T>(body: IQueryFormat, token?: string) {
        const encryptedData = this.encryptedPayload(body);
        const resp = <any>await this.http.post<T[]>(environment.GUDIYA_ENTERPRISES_BE_HOST_PORT_SITES + `${this.modelPath}/query`, encryptedData, this.getRequestOptions()).toPromise();
        if (this.isEncrypted) return this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
        else return resp.data;
    }

    async getByIdUser<T>(id: string): Promise<T> {
        const resp = <any>await this.http.get<T>(environment.GUDIYA_ENTERPRISES_BE_HOST_PORT_SITES + `${this.modelPath}/get-by-id/${id}`, this.getRequestOptions()).toPromise();
        if (this.isEncrypted) return this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
        else return resp.data;
    }

    async saveUser<T>(body: T) {
        const amToken = <any>await this.getAMToken();
        const encryptedData = this.encryptedPayload(body);
        const resp = <any>await this.http.post<T>(environment.GUDIYA_ENTERPRISES_BE_HOST_PORT_SITES + `${this.modelPath}/save-single-or-multiple`, encryptedData, this.getRequestOptions()).toPromise();
        if (this.isEncrypted) return this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
        else return resp.data;
    }

    async updateUser<T>(id: string, body: Partial<T>, queryParams?: any) {
        const encryptedData = this.encryptedPayload(body);
        const resp = <any>await this.http.put<T>(environment.GUDIYA_ENTERPRISES_BE_HOST_PORT_SITES + `${this.modelPath}/update-by-id/${id}`, encryptedData, {
            params: queryParams,
            headers: this.getRequestOptions().headers,
        }).toPromise();
        if (this.isEncrypted) return this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
        else return resp.data;
    }

    async permanentDeleteUser<T>(id: string) {
        const resp = <any>await this.http.delete<T>(environment.GUDIYA_ENTERPRISES_BE_HOST_PORT_SITES + `${this.modelPath}/${id}`, this.getRequestOptions()).toPromise();
        if (this.isEncrypted) return this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
        else return resp.data;
    }

    async paymentReceiptsUpload(body: any) {
        const encryptedData = this.encryptedPayload(body);
        const resp = <any>await this.http.post<IAPIResponse<any>>(environment.GUDIYA_ENTERPRISES_BE_HOST_PORT_SITES + EModelApiPaths.CUSTOM_API_BASE + `/${environment.USER_PATH}` + EModelApiPaths.FILE_UPLOAD, encryptedData, this.getRequestOptions()).toPromise();
        if (this.isEncrypted) return this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
        else return resp.data;
    }

    async forgotPassword(body: any) {
        const encryptedData = this.encryptedPayload(body);
        const resp = <any>await this.http.post<IAPIResponse<any>>(environment.GUDIYA_ENTERPRISES_BE_HOST_PORT_SITES + EModelApiPaths.CUSTOM_API_BASE + `/${environment.USER_PATH}` + EModelApiPaths.FORGOT_PASSWORD, encryptedData,  this.getRequestOptions()).toPromise();
        if (this.isEncrypted) return this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
        else return resp.data;
    }

    async newUserRegister(body: any) {
        const encryptedData = this.encryptedPayload(body);
        const resp = <any>await this.http.post<IAPIResponse<any>>(environment.GUDIYA_ENTERPRISES_BE_HOST_PORT_SITES + EModelApiPaths.CUSTOM_API_BASE + `/${environment.USER_PATH}` + EModelApiPaths.NEW_USER_REGISTRATION, encryptedData,  this.getRequestOptions()).toPromise();
        if (this.isEncrypted) return this.utilsService.getDecryptedObject(resp.encryptedData, environment.crypto.passJWT);
        else return resp.data;
    }

    clearLocalStorage() {
        localStorage.clear();
        this.gUser = <any>undefined;
        this.token.accessToken = '';
        this.token.refreshToken = '';
    }

    async logout() {
        this.clearLocalStorage();
        await this.router.navigate(['/home']);
        let defaultAMToken: any = await this.getAMToken();
        window.localStorage.setItem(ELocalStorage.DEFAULT_AM_AUTH, defaultAMToken.token);
    }
}
